import React from "react";
import { Container, Close, Content } from "./styles";

export const Modal = (props) => {
  return (
    <>
      {props.visible && (
        <Container className="modal" aria-modal="true" role="dialog">
          <Close
            className="close"
            onClick={() => {
              props.setVisible(false);
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              width="30"
              height="30"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </Close>
          <Content>{props.children}</Content>
        </Container>
      )}
    </>
  );
};
